import { Cron } from '../api'
import { TransfersV2 } from '../api-v2'
import { mapV1ExpediteTransferRequestToV2ExpediteTransferRequestBody } from '../api-v2/mappings/map-transfers'
import { ApiVersionDelagator } from "./api-delegator"
/**
 * @typedef {import('../api-v2/js-doc').V1ExpediteTransferRequest} V1ExpediteTransferRequest
 * @typedef {import('../api-v2/js-doc').V2MappingOptions} V2MappingOptions
 */

export class TransfersApiDelegator extends ApiVersionDelagator {
  /**
   * @param {string} clientId - ID of the client
   * @param {V1ExpediteTransferRequest} v1Request - V1 expedite transfer request
   * @returns {Promise<any>}
   */
  async initiateExpediteTransfer (clientId, v1Request) {
    return await this.runWriteApiCalls(
      clientId,
      v1Request,
      this.#initiateExpediteTransferV1,
      this.#initiateExpediteTransferV2,
      {
        operationName: 'initiate-expedite-transfer',
      }
    )
  }

  /**
   * @param {V1ExpediteTransferRequest} v1Request - V1 expedite transfer request
   * @returns {Promise<V1InvoiceResponse[]>}
   */
  async #initiateExpediteTransferV1 (v1Request) {
    return Cron.runClientWire(v1Request)
  }

  /**
   * @param {V1ExpediteTransferRequest} v1Request - V1 expedite transfer request
   * @param {V2MappingOptions} v2MappingOptions - V2 mapping options
   * @returns {Promise<any>}
   */
  async #initiateExpediteTransferV2 (v2MappingOptions, v1Request) {
    const v2Request = mapV1ExpediteTransferRequestToV2ExpediteTransferRequestBody(v2MappingOptions, v1Request)
    return await new TransfersV2().initiateExpediteTransfer(v2Request)
  }
}
